import http from '../_http'

//partner license api
const license = {
  //default
  listLicense: (m) => { return http.post(`manager/billing/license/list`, m); },
  detailLicense: (m) => { return http.get(`manager/billing/license/${m.id}`); },

  //crud
  insertLicense: (m) => { return http.post(`manager/billing/license`, m); },
  updateLicense: (m) => { return http.put(`manager/billing/license`, m); },
  deleteLicense: (m) => { return http.delete(`manager/billing/license/${m.id}`)},

  //service
  serviceLicense: (m) => { return http.get(`manager/billing/license/service`, m); },

  //publish
  publishLicense: (m) => { return http.post(`manager/billing/license/publish`, m); }
}

export default license

export { license }